/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */


import {Component} from '@angular/core';
export class VerticalNavGroupChildren {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: "clr-vertical-nav-group-children",
    template: `
        <ng-content></ng-content>
    `
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function VerticalNavGroupChildren_tsickle_Closure_declarations() {
/** @type {?} */
VerticalNavGroupChildren.decorators;
/**
 * @nocollapse
 * @type {?}
 */
VerticalNavGroupChildren.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
